import { ProductFindingView, ProductRevisionView } from 'api';

export interface FindingsOverTimePoint {
  label: string;
  total: number;
}

export interface DashboardMetric {
  key: 'openFindings' | 'craRelevantProductRevisions';
  value: number;
  deltaText: number;
  tone: 'danger' | 'success';
  actionLabel?: string;
  actionLink?: string;
}

export interface DashboardFinding {
  componentName: string;
  version: string;
  finding: string;
  severity: 'Critical' | 'Major' | 'Moderate' | 'Minor';
}

export interface DashboardProductFamily {
  name: string;
  criticalFindings: number;
  majorFindings: number;
  description: string;
}

export interface DashboardOverview {
  chartSummaryValue: number;
  findingsOverTime: ReadonlyArray<FindingsOverTimePoint>;
  metrics: ReadonlyArray<DashboardMetric>;
  topFindings: ReadonlyArray<ProductFindingView>;
  recentlyUsedRevisions: ReadonlyArray<ProductRevisionView>;
  findingsActionLink: string;
  recentlyUsedRevisionsActionLink: string;
}

export const dashboardOverviewMock: DashboardOverview = {
  chartSummaryValue: 117,
  findingsOverTime: [
    { label: 'Jan', total: 24 },
    { label: 'Feb', total: 27 },
    { label: 'Mar', total: 21 },
    { label: 'Apr', total: 22 },
    { label: 'May', total: 22 },
    { label: 'Jun', total: 31 },
    { label: 'Jul', total: 21 },
    { label: 'Aug', total: 27 },
    { label: 'Sep', total: 27 },
    { label: 'Oct', total: 27 },
    { label: 'Nov', total: 81 },
    { label: 'Dec', total: 117 },
  ],
  metrics: [
    {
      key: 'openFindings',
      value: 117,
      deltaText: 4,
      tone: 'danger',
    },
    {
      key: 'craRelevantProductRevisions',
      value: 1024,
      deltaText: 4,
      tone: 'success',
      actionLabel: 'Show',
      actionLink: '/products',
    },
  ],
  topFindings: [],
  recentlyUsedRevisions: [],
  findingsActionLink: '/findings',
  recentlyUsedRevisionsActionLink: '/components',
};
